(function () {
    'use strict';

    var module = angular.module('uwAgenda.programinfo', [
        'uwAgenda.global'
    ]);

})();